import {createAction, createActionGroup, emptyProps, props} from '@ngrx/store';
import { AuthEntity } from './auth.models';
import {User, UserPermissions} from "../auth-http.interface";

export const initAuth = createAction('[Auth Page] Init');

export const loadAuthSuccess = createAction(
  '[Auth/API] Load Auth Success',
  props<{ auth: AuthEntity[] }>()
);

export const loadAuthFailure = createAction(
  '[Auth/API] Load Auth Failure',
  props<{ error: any }>()
);

export const AuthenticationActions = createActionGroup({
  source: 'Authentication',
  events: {
    'Sign In': props<{ identity: string; password: string }>(),
    'Sign In Success': props<{ token: string, user: User }>(),
    'Sign In Failure': props<{ error: any }>(),

    'OAuth Sign In': emptyProps(),

    'Sign Out': emptyProps(),
    'Sign Out Success': emptyProps(),
    'Sign Out Failure': props<{ error: any }>(),
  },
});

export const UserPermissionActions = createActionGroup({
  source: 'User Permissions',
  events: {
    'Get Permissions': (roleId: number) => ({ roleId }),
    'Get Permissions Success': props<{ permissions: UserPermissions }>(),
    'Get Permissions Failure': props<{ error: any }>(),
  },
});

export const UserActions = createActionGroup({
  source: 'User',
  events: {
    'Get User': emptyProps(),
    'Get User Success': props<{ user: User }>(),
    'Get User Failure': props<{ error: any }>(),

    'Update User': props<{ user: Partial<User> }>(),
    'Change Password': props<{ currentPassword: string, password: string, passwordConfirmation: string }>(),
  },
});
